import { registerPlugin } from '@capacitor/core';
const SmsSender = registerPlugin('SmsSender');
export * from './definitions';
export { SmsSender };
//# sourceMappingURL=index.js.map